import { css } from "@emotion/css"
import React from "react"

import Image from "@p-ban/common/src/components/html/Image"

import type EstimateValues from "../../../../../types/params"
import getBaseColor from "../../../../service/getBaseColor"

import black from "../../../../img/color/black.png"
import blue from "../../../../img/color/blue.png"
import green from "../../../../img/color/green.png"
import matteBlack from "../../../../img/color/matteBlack.png"
import orange from "../../../../img/color/orange.png"
import purple from "../../../../img/color/purple.png"
import red from "../../../../img/color/red.png"
import white from "../../../../img/color/white.png"
import yellow from "../../../../img/color/yellow.png"
import silkBlack from "./img/black.png"
import silkWhite from "./img/white.png"
import silkYellow from "./img/yellow.png"

const images = { green, red, blue, yellow, white, black, matteBlack, purple, orange }
const silkImages = { white: silkWhite, black: silkBlack, yellow: silkYellow }

type Props = {
  values: EstimateValues
  silkColor: "white" | "black" | "yellow"
}

const SilkPrintColorImage = ({ values, silkColor }: Props) => {
  const color = getBaseColor(values)

  return (
    <span className={style}>
      <Image src={images[color]} alt="" width={30} height={30} />
      <Image src={silkImages[silkColor]} alt="" width={30} height={30} />
    </span>
  )
}

export default SilkPrintColorImage

const style = css`
  position: relative;
  width: 30px;
  height: 30px;
  > * {
    position: absolute;
    top: 0;
    left: 0;
  }
`
